import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Paper,
  Box,
  Divider,
  MenuItem,
  Typography,
  Menu,
  Button,
  ListItemIcon,
  ListItemText,
  Card,
  Select,
  Grid,
  CircularProgress,
  Alert,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../store/store";
import DateRangeWithTime from "../summary/dateRange";
import CachedIcon from '@mui/icons-material/Cached';
import MenuIcon from '@mui/icons-material/Menu';
import moment from "moment";
import { getNumberUnits } from "../../helper/service";
import ReactApexChart from "react-apexcharts";
import { checkWithSubstanceOneDecimal } from "../../constants";
import { GetSubstanceDetailDetection } from "../../store/thunk/detection";
import { setActiveLocarionRow } from "../../store/slices/detectionSlice";
import { LabelIconsDetection } from "./svgIcon/labelIconDetection";
import { CircleSVG } from "./svgIcon";
import { convertTemperatureToCelsius } from "../../config/util";
import DropdownMenu from "./customeDropdown";
import { ExpandableDescription } from "../../helper/expandableText";
import { useSearchParams } from "react-router-dom";
import { RootState } from "../../store/store";

export default function DetectionDetailsComponent(props: any) {
  const {
    setSelectedValue,
    setSortValue,
    sortValue,
    data,
    selectedValue,
    setDateRangeChange,
    dateRange,
    substanceKey,
    newDashboardLoader,
    categoryList,
  } = props;

  const [searchParams] = useSearchParams();
  const range = searchParams.get("range");
  useEffect(() => {
    const now = moment(); // Current time

    if (range === "day") {
      setDateRangeChange({
        startDate: now.clone().subtract(24, "hours"), // 24 hours ago from now
        endDate: now, // Current time
      });
    } else if (range === "week") {
      setDateRangeChange({
        startDate: moment().startOf("week"),
        endDate: now, // Current time
      });
    } else if (range === "month") {
      setDateRangeChange({
        startDate: moment().startOf("month"),
        endDate: now, // Current time
      });
    }
  }, [range]);


  const { substanceConfigurationList } = useAppSelector(
    (state) => state.substanceSlice
  );
  const tableRef = useRef<any>(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);

  const [anchorEl1, setAnchorEl1] = useState(null);
  const open2 = Boolean(anchorEl1);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickSort = (event: any) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseSort = () => {
    setAnchorEl1(null);
  };
  const handleSelecte = (values: any) => {
    setSelectedValue(values);
    handleClose();
  };
  const handleSortSelecte = (values: any) => {
    setSortValue(values);
    handleCloseSort();
  };

  useEffect(() => {
    const handleRowClick = (event: { currentTarget: any }) => {
      // Get the clicked row
      const row = event.currentTarget;

      // Scroll the window down if there is more content
      window.scrollBy({
        top: row.getBoundingClientRect().height, // Scroll by row height
        behavior: "smooth", // Smooth scrolling
      });
    };

    // Attach click event to all rows in the last section
    const table = tableRef.current;
    if (table) {
      const rows = table.querySelectorAll("tbody tr:last-child");
      rows.forEach(
        (row: {
          addEventListener: (arg0: string, arg1: (event: any) => void) => any;
        }) => row.addEventListener("click", handleRowClick)
      );
    }

    // Cleanup function
    return () => {
      if (table) {
        const rows = table.querySelectorAll("tbody tr:last-child");
        rows.forEach(
          (row: {
            removeEventListener: (
              arg0: string,
              arg1: (event: any) => void
            ) => any;
          }) => row.removeEventListener("click", handleRowClick)
        );
      }
    };
  }, []);

  const substanceD =
    substanceConfigurationList.length > 0
      ? substanceConfigurationList.find(
        (item: any) => item.substanceKey === substanceKey
      )
      : {};
  return (
    <Box sx={{ p: 2, width: "100%", mx: "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontWeight: 800,
              fontSize: "22px",
            }}
          >
            {selectedValue?.displayName !== ""
              ? selectedValue?.displayName
              : substanceD?.displayName}
          </Typography>
          <Box
            onClick={handleClick}
            sx={{
              minWidth: "40px",
              borderRadius: "7px",
              padding: "7px 10px",
              borderColor: "#ccc",
              border: "1px solid #B0B0B0",
              color: "black",
              cursor: "pointer",
              backgroundColor: "#fff",
              display: "flex",
            }}
          >
            <MenuIcon color="primary" />
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Menu
            anchorEl={anchorEl}
            open={open1}
            onClose={handleClose}
            PaperProps={{
              sx: {
                width: 220,
                marginTop: 1,
                borderRadius: 2,
                boxShadow: 3,
                paddingY: 1,
                overflowY: "scroll",
                maxHeight: 350,
              },
            }}
          >
            <Typography
              variant="body2"
              sx={{ px: 2, py: 1, fontWeight: "bold", color: "#666" }}
            >
              Choose Characteristics
            </Typography>
            <Divider />
            {
              substanceConfigurationList.filter((val: any) =>
                !val.category_id &&
                val.group !== val.substanceKey &&
                val.group !== val.substanceKey || (!val.category_id && val.group === 'thi')
              ).map((item: any) => {
                return (<MenuItem
                  key={item.substanceKey}
                  onClick={() => handleSelecte(item)}
                  selected={item.substanceKey === selectedValue?.substanceKey} // Highlight "Temp"
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: "#1976d2",
                      color: "white",
                    },
                    "&:hover": { backgroundColor: "#e3f2fd" },
                  }}
                >
                  <ListItemIcon>
                    <img src={`/assets/images/Arrow_alt_lright_alt.svg`} />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ textTransform: "uppercase" }}
                    primary={item.displayName}
                  />
                </MenuItem>)
              })
            }
            {categoryList.length > 0 && substanceConfigurationList.length > 0 &&
              categoryList.map((category: any) => {
                const substanceList = substanceConfigurationList?.filter((val: any) =>
                  val.category_id === category.sk &&
                  (val.group !== val.substanceKey || val.substanceKey !== "pm2dot5psd")
                );
                if (!substanceList?.length) return;
                return (
                  <>
                    <Typography variant="body2" sx={{ px: 2, py: 1, fontWeight: "bold", color: "#666" }}>
                      {category.category_name}
                    </Typography>
                    {
                      substanceList?.map((item: any) => {
                        return (<MenuItem
                          key={item.substanceKey}
                          onClick={() => handleSelecte(item)}
                          selected={item.substanceKey === selectedValue?.substanceKey} // Highlight "Temp"
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "#1976d2",
                              color: "white",
                            },
                            "&:hover": { backgroundColor: "#e3f2fd" },
                          }}
                        >
                          <ListItemIcon>
                            <img src={`/assets/images/Arrow_alt_lright_alt.svg`} />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ textTransform: "uppercase" }}
                            primary={item.displayName}
                          />
                        </MenuItem>)
                      })
                    }
                  </>
                )
              })
            }
          </Menu>
          <Box
            sx={{ width: { xs: "100%", md: "23em", alignItems: "end" }, mr: 2 }}
          >
            <DateRangeWithTime
              setDateRangeChange={setDateRangeChange}
              dateRange={dateRange}
            />
          </Box>
          <Typography sx={{ marginRight: 1 }}>Sort by:</Typography>
          <Box
            onClick={handleClickSort}
            sx={{
              minWidth: "40px",
              borderRadius: "7px",
              padding: "7px 10px",
              borderColor: "#ccc",
              border: "1px solid #B0B0B0",
              color: "black",
              cursor: "pointer",
              display: "flex",
              backgroundColor: "#fff",
            }}
          >
            <Typography sx={{ textTransform: "capitalize" }}>
              {sortValue == "fcl" ? "Facility" : "Risk"}
            </Typography>
            <img src={`/assets/images/Expand_down_light.svg`} />
          </Box>
          <Menu
            anchorEl={anchorEl1}
            open={open2}
            onClose={handleCloseSort}
            PaperProps={{
              sx: {
                width: 220,
                marginTop: 1,
                borderRadius: 2,
                boxShadow: 3,
                paddingY: 1,
                overflowY: "scroll",
                maxHeight: 350,
              },
            }}
          >
            <MenuItem
              onClick={() => handleSortSelecte("fcl")}
              selected={"fcl" === sortValue}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#1976d2",
                  color: "white",
                },
                "&:hover": { backgroundColor: "#e3f2fd" },
              }}
            >
              <ListItemIcon>
                <img src={`/assets/images/Arrow_alt_lright_alt.svg`} />
              </ListItemIcon>
              <ListItemText
                sx={{ textTransform: "uppercase" }}
                primary={"Facility"}
              />
            </MenuItem>
            <MenuItem
              onClick={() => handleSortSelecte("index")}
              selected={"index" === sortValue}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#1976d2",
                  color: "white",
                },
                "&:hover": { backgroundColor: "#e3f2fd" },
              }}
            >
              <ListItemIcon>
                <img src={`/assets/images/Arrow_alt_lright_alt.svg`} />
              </ListItemIcon>
              <ListItemText
                sx={{ textTransform: "uppercase" }}
                primary={"Risk"}
              />
            </MenuItem>
          </Menu>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table ref={tableRef}>
          <TableHead
            sx={{ "& th": { padding: "0px !important" }, height: "50px" }}
          >
            <TableRow>
              <TableCell />
              <TableCell>Facility</TableCell>
              <TableCell>Floor</TableCell>
              <TableCell>Room</TableCell>
              <TableCell>Devices</TableCell>
              <TableCell>Current value</TableCell>
              <TableCell>Frequency</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.length > 0 &&
              data.map((row: any, index: any) => (
                <ExpandableTableRow key={index} row={row} dateRange={dateRange} />
              ))}

            {data && data.length == 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box
                    sx={{
                      p: 2,
                      pb: 0,
                      gap: 2,
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    Data not available...!
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {newDashboardLoader && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.6)", // Semi-transparent white overlay
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999, // Ensure it appears above everything
            }}
          >
            <CircularProgress size={40} />
          </Box>
        )}
      </TableContainer>
    </Box>
  );
}
const ExpandableTableRow = ({ row, dateRange }: any) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const userData = useAppSelector((store) => store?.authReducer?.userData);
  const { themeMode } = useAppSelector((state: any) => state.themeSlice);
  const { substancedetails } = useAppSelector((state) => state.substanceSlice);
  const {
    detectionDetialsGraphData,
    activeLocarionRow,
    loaderDetialsGraphData,
  } = useAppSelector((state) => state.detection);
  const [intervalOption, setIntervalOption] = useState<any>([
    { label: "1 Minute", value: "1m", disable: false },
    { label: "5 Minutes", value: "5m", disable: false },
    { label: "1 Hour", value: "1h", disable: true },
    { label: "1 Day", value: "1d", disable: true },
    { label: "7 Days", value: "7d", disable: true },
    { label: "30 Days", value: "30d", disable: true },
  ]);
  const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
  const [countDateRange, setDateRangeCount] = useState(0);
  const [dateRange1, setDateRangeChange1] = useState<any>({
    startDate: moment().startOf("minute").subtract(3, "hour"),
    endDate: moment().startOf("minute"),
  });
  const [interval, setInterval] = React.useState("5m");
  const [graphDataSeries, setGraphDataSeries] = React.useState<any>([]);
  var xcount = 0;
  var chartLabels: any = [];
  const [graphDataOptions, setGraphOptions] = React.useState<any>({
    options: {
      chart: {
        height: 350,
        type: "line",
        toolbar: {
          tools: {
            zoom: false, // Disables zooming tool
            zoomin: false, // Disables zoom-in button
            zoomout: false, // Disables zoom-out button
          },
        },
        zoom: {
          enabled: false, // Completely disables zooming
        },
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      markers: {
        size: 5,
      },
      tooltip: {
        theme: themeMode,
        x: {
          show: true, // Show tooltip on x-axis
          formatter: function (val: any) {
            return new Date(val).toLocaleString(); // Convert timestamp to local date string
          },
        },
        y: {
          title: {
            formatter: function (val: any, opt: any) {
              // return opt.w.globals.labels[opt.dataPointIndex] + " : ";
              return;
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        rotateAlways: false,
        categories: [],
        // type: "datetime",
        tooltip: {
          enabled: false,
        },
        forceNiceScale: true,
        labels: {
          datetimeUTC: false,
          formatter: function (value: any) {
            let modulo: any = Math.round(chartLabels.length / 10);
            xcount = xcount + 1;
            if (xcount % (modulo || 1) === 0) {
              return [
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format("hh:mm A"),
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format("DD-MMM-YY"),
              ]; // Format the date as per your requirement
            }
            return "";
          },
        },
      },
      yaxis: {
        forceNiceScale: true,
        labels: {
          formatter: (value: any) => {
            return value === Infinity
              ? 0
              : value > 0 && value < 0.1
                ? Number(value).toFixed(4)
                : getNumberUnits(Math.round(value * 100) / 100);
          },
        },
      },
    },
  });

  const handleDetailGraphData = () => {
    setOpen(!open);
    if (!open === false) {
      // dispatch(setActiveLocarionRow(""));
    }
  };
  const handleChangeInterval = (event: any) => {
    setInterval(event.target.value);
  };
  useEffect(() => {
    setDateRangeChange1(dateRange)
  }, [dateRange])
  useEffect(() => {
    if (!activeLocarionRow) {
      setOpen(false)
    }
  }, [activeLocarionRow])
  useEffect(() => {
    let start: any = "";
    let end: any = "";
    let hoursDiff: any = 0;
    let daysDiff: any = 0;

    if (typeof dateRange1?.startDate === "string") {
      start = moment(dateRange1?.startDate);
      end = moment(dateRange1?.endDate);
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    } else {
      start = dateRange1?.startDate;
      end = dateRange1?.endDate;
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    }

    if (hoursDiff > 12) {
      setInterval(daysDiff > 14 ? "1d" : "1h");
      setIntervalOption([
        { label: "1 Minute", value: "1m", disable: true },
        { label: "5 Minutes", value: "5m", disable: true },
        { label: "1 Hour", value: "1h", disable: daysDiff > 14 ? true : false },
        { label: "1 Day", value: "1d", disable: false },
        {
          label: "7 Days",
          value: "7d",
          disable: daysDiff >= 14 ? false : true,
        },
        {
          label: "30 Days",
          value: "30d",
          disable: daysDiff >= 60 ? false : true,
        },
      ]);
    } else if (hoursDiff > 3) {
      setInterval("5m");
      setIntervalOption([
        { label: "1 Minute", value: "1m", disable: true },
        { label: "5 Minutes", value: "5m", disable: false },
        { label: "1 Hour", value: "1h", disable: daysDiff > 14 ? true : false },
        { label: "1 Day", value: "1d", disable: true },
        {
          label: "7 Days",
          value: "7d",
          disable: daysDiff >= 14 ? false : true,
        },
        {
          label: "30 Days",
          value: "30d",
          disable: daysDiff >= 60 ? false : true,
        },
      ]);
    } else if (hoursDiff <= 3) {
      setInterval(hoursDiff <= 1 ? "1m" : "5m");
      setIntervalOption([
        {
          label: "1 Minute",
          value: "1m",
          disable: hoursDiff <= 1 ? false : true,
        },
        { label: "5 Minutes", value: "5m", disable: false },
        {
          label: "1 Hour",
          value: "1h",
          disable: hoursDiff < 2 ? true : false,
        },
        { label: "1 Day", value: "1d", disable: true },
        {
          label: "7 Days",
          value: "7d",
          disable: daysDiff >= 14 ? false : true,
        },
        {
          label: "30 Days",
          value: "30d",
          disable: daysDiff >= 60 ? false : true,
        },
      ]);
    } else {
      setInterval("5m");
      setIntervalOption([
        { label: "1 Minute", value: "1m", disable: true },
        { label: "5 Minutes", value: "5m", disable: false },
        { label: "1 Hour", value: "1h", disable: daysDiff > 14 ? true : false },
        { label: "1 Day", value: "1d", disable: false },
        {
          label: "7 Days",
          value: "7d",
          disable: daysDiff >= 14 ? false : true,
        },
        {
          label: "30 Days",
          value: "30d",
          disable: daysDiff >= 60 ? false : true,
        },
      ]);
    }
    setDateRangeCount((prevValues) => prevValues + 1);
  }, [dateRange1]);
  useEffect(() => {
    if (open === true) {
      if (dateRange1 !== null) {
        const params = {
          interval: interval,
          location: row.loc,
          substanceKey: row.substanceKey,
          fromDate: moment(dateRange1.startDate).format("Y-MM-DD HH:mm:ssZ"),
          toDate: moment(dateRange1.endDate).format("Y-MM-DD HH:mm:ssZ"),
        };
        dispatch(
          GetSubstanceDetailDetection({ request: params, location: row.loc, previousData: detectionDetialsGraphData, tenantCode : items && items.tenantId ? items.tenantCode : userData.tenantCode })
        );
      }
    }
  }, [open, interval, countDateRange]);

  useEffect(() => {
    const { xaxis } = graphDataOptions.options;
    const { options } = graphDataOptions;
    let colors: any = [];
    let valuesData: any = [];
    let categories: any = [];
    if (
      detectionDetialsGraphData[row.loc]?.measures &&
      detectionDetialsGraphData[row.loc].measures.length > 0
    ) {
      const sortedArray = [...detectionDetialsGraphData[row.loc].measures].sort(
        (c1: any, c2: any) => c1.time - c2.time
      );
      sortedArray.map((val: any) => {
        let num = typeof val.value;
        let value =
          num === "number" ? parseFloat(val.value).toFixed(4) : val.value;
        colors.push(val.color);
        valuesData.push(value < 0 ? 0 : value);
        const date = moment?.unix(val.time)?.utc(false).format("DD-MM LT");
        // categories.push(date);
        categories.push(val.time * 1000);
      });
    }
    chartLabels = categories;
    xcount = 0;
    setGraphDataSeries(valuesData);
    setGraphOptions({
      ...graphDataOptions,
      options: {
        ...options,
        xaxis: {
          ...xaxis,
          categories: categories,
          labels: {
            datetimeUTC: false,
            formatter: function (value: any) {
              let modulo: any = Math.round(categories.length / 10);
              xcount = xcount + 1;
              if (xcount % (modulo || 1) === 0) {
                return [
                  moment(value)
                    .tz(userData?.timezone || moment.tz.guess())
                    .format("hh:mm A"),
                  moment(value)
                    .tz(userData?.timezone || moment.tz.guess())
                    .format("DD-MMM-YY"),
                ]; // Format the date as per your requirement
              }
              return "";
            },
          },
        },
        tooltip: {
          theme: themeMode,
          x: {
            show: true, // Show tooltip on x-axis
            formatter: function (_: any, { dataPointIndex, seriesIndex, w }: any) {
              // Manually get the correct x-value for this marker
              let actualXValue = categories[dataPointIndex];
              return moment(actualXValue)
                .tz(userData?.timezone || moment.tz.guess())
                .format("DD-MMM-YYYY hh:mm A");
            },
          },
          y: {
            title: {
              formatter: function (val: any, opt: any) {
                // return opt.w.globals.labels[opt.dataPointIndex] + " : ";
                return;
              },
            },
          },
        },
        colors: ["#577ec6"],
        markers: {
          ...options?.markers,
          size: 3,
          discrete: colors.map((val: any, index: number) => {
            return {
              seriesIndex: 0,
              dataPointIndex: index,
              fillColor: val,
              strokeColor: "#fff",
              size: 5,
              shape: "circle",
            };
          }),
        },
      },
    });
  }, [detectionDetialsGraphData]);

  const { configureListNew } = useAppSelector(
    (state: RootState) => state.deviceSlice
  );
  const getDeviceIcon = (device_id: any) => {
    const providerType = configureListNew.find((item: any) => {
      const deviceId = item?.pk?.split("|")[1];
      return deviceId === device_id;
    });

    if (providerType?.provider === "Verkada") {
      return (
        <img
          src="/assets/images/Verkada.png"
          width={24}
          height={24}
          alt="Verkada"
          style={{ objectFit: "contain" }}
        />
      );
    } else {
      return (
        <img
          src="/assets/images/ieqDevice.png"
          width={24}
          height={24}
          alt="IEQ"
          style={{ objectFit: "contain" }}
        />
      );
    }
  };


  const { value, value1, count, icon, isoIndex, substanceKey, displayName, unit, color } = row;

  let twoPlacedFloat: any =
    value != null
      ? Number.isInteger(value)
        ? value
        : parseInt(value).toFixed(2)
      : "--";
  twoPlacedFloat =
    twoPlacedFloat != "--"
      ? getNumberUnits(twoPlacedFloat, substanceKey, unit)
      : "--";
  let twoPlacedFloat1 =
    value1 != null
      ? Number.isInteger(value1)
        ? value1
        : parseInt(value1).toFixed(2)
      : "--";
  twoPlacedFloat1 =
    twoPlacedFloat1 != "--"
      ? getNumberUnits(twoPlacedFloat1, substanceKey, unit)
      : "--";

  return (
    <>
      <TableRow>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "4px",
              border: "1px solid #E0E0E0",
              cursor: "pointer",
              backgroundColor: "transparent",
              // '&:hover': {
              //   backgroundColor: '#F5F5F5'
              // }
            }}
            onClick={() => handleDetailGraphData()}
          >
            {open ? (
              <KeyboardArrowDown />
            ) : (
              <KeyboardArrowRight />
            )}
          </Box>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <img src={`/assets/images/FacilityIcon.svg`} />
            <ExpandableDescription description={row.facilityName} characterLimit={7} />
          </Box>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <img src={`/assets/images/FloorIcon.svg`} />
            <ExpandableDescription description={row.floorName} characterLimit={7} />
          </Box>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <LabelIconsDetection type={"R"} />
            <ExpandableDescription description={row.roomName} characterLimit={7} />
          </Box>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              justifyContent: "left",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <img src={`/assets/images/DeviceIcon.svg`} />
            {row.device_id}
            {getDeviceIcon(row.device_id)}
          </Box>
        </TableCell>
        <TableCell>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <CircleSVG
              getnumber={""}
              bgcolor={row.color}
              fontColor={""}
              size={15}
              themeMode={themeMode}
            />
            {(() => {
              if (substanceKey === "thir") return `${twoPlacedFloat1} ${unit}`;
              else if (substanceKey === "isopm10psd")
                return isoIndex || "-";
              else if (substanceKey === "temperature")
                return (userData?.temperature_unit === "C" && parseFloat(twoPlacedFloat))
                  ? convertTemperatureToCelsius(twoPlacedFloat)?.value
                  : `${twoPlacedFloat} ${unit} `;
              return `${twoPlacedFloat} ${unit}`
            })()}
          </div>
        </TableCell>
        <TableCell>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <CircleSVG
                getnumber={
                  row.frequencyData["black"] !== undefined &&
                    row.frequencyData["black"] !== 0
                    ? row.frequencyData["black"].toString()
                    : "0"
                }
                bgcolor={"#000000"}
                fontColor={""}
                size={30}
                themeMode={themeMode}
              />
              <CircleSVG
                getnumber={
                  row.frequencyData["red"] !== undefined &&
                    row.frequencyData["red"] !== 0
                    ? row.frequencyData["red"].toString()
                    : "0"
                }
                bgcolor={"#871014"}
                fontColor={""}
                size={30}
                themeMode={themeMode}
              />
              <CircleSVG
                getnumber={
                  row.frequencyData["yellow"] !== undefined &&
                    row.frequencyData["yellow"] !== 0
                    ? row.frequencyData["yellow"].toString()
                    : "0"
                }
                bgcolor={"#FFEF5C"}
                fontColor={""}
                size={30}
                themeMode={themeMode}
              />
            </div>
          </div>
        </TableCell>
      </TableRow>
      {open && (
        <TableRow>
          <TableCell colSpan={7} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
            >
              <Paper style={{ padding: "10px", margin: "10px" }}>
                <Box sx={{ display: "-webkit-flex" }} my={2}>
                  <Box
                    sx={{ marginRight: "10px", width: " 100%", maxWidth: 180 }}
                  >
                    <Select
                      variant="outlined"
                      displayEmpty
                      name={"interval"}
                      sx={{
                        width: "100%",
                        height: 42,
                        // marginRight: 2,
                        background: "#FFFFFF",
                        border: "1.15px solid #E4E4E4",
                        borderRadius: "27.6px !important",
                        // padding: "7px  !important",
                        "& .MuiSelect-select": {
                          opacity: interval == null ? "0.5" : "1",
                        },
                      }}
                      onChange={handleChangeInterval}
                      value={interval}
                      renderValue={
                        interval !== null ? undefined : () => "Select Interval"
                      }
                    >
                      {intervalOption.map((item: any) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          disabled={item.disable}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100%", md: "23em", alignItems: "end" },
                      mr: 2,
                    }}
                  >
                    <DateRangeWithTime
                      setDateRangeChange={setDateRangeChange1}
                      dateRange={dateRange1}
                      name={"detectionDateRange" + row.loc}
                    />
                  </Box>
                </Box>
                <Box sx={{ position: "relative" }}>
                  <Card
                    sx={{
                      minWidth: "100%",
                      pointerEvents: (loaderDetialsGraphData && activeLocarionRow === row.loc) ? "none" : "auto", // Disable interactions when flag is true
                      opacity: (loaderDetialsGraphData && activeLocarionRow === row.loc) ? 0.6 : 1, // Reduce opacity when flag is true
                      filter: (loaderDetialsGraphData && activeLocarionRow === row.loc) ? "blur(2px)" : "none", // Slight blur for better UI
                    }}
                  >
                    {(!loaderDetialsGraphData && activeLocarionRow === row.loc) &&
                      graphDataSeries.length === 0 && (
                        <Typography
                          sx={{
                            textAlign: "center",
                            m: 1,
                            fontSize: 14,
                            display: "center",
                            justifyContent: "center",
                          }}
                        >
                          Graph data is not available for characteristics{" "}
                          {row?.displayName?.toUpperCase()} for the selected
                          date range.
                          <br />
                          Please change the date range or select another
                          characteristics.
                        </Typography>
                      )}
                    {graphDataSeries.length > 0 && (
                      <ReactApexChart
                        options={{
                          ...graphDataOptions.options,
                          tooltip: {
                            ...graphDataOptions?.options.tooltip,
                            y: {
                              ...graphDataOptions?.options?.tooltip?.y,
                              formatter: function (value: any) {
                                return checkWithSubstanceOneDecimal.includes(
                                  row?.substanceKey
                                )
                                  ? value.toFixed(1)
                                  : value;
                              },
                            },
                          },
                        }}
                        // options={graphDataOptions.options}
                        series={[
                          {
                            data: graphDataSeries,
                          },
                        ]}
                        type="line"
                        height={350}
                      />
                    )}
                  </Card>
                  <Grid>
                    {(loaderDetialsGraphData && activeLocarionRow === row.loc) && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(255, 255, 255, 0.6)", // Semi-transparent white overlay
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 10, // Ensure it appears above everything
                        }}
                      >
                        <CircularProgress size={40} />
                      </Box>
                    )}
                  </Grid>
                </Box>
              </Paper>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
